import { Outlet } from 'react-router-dom'

export const TextPage = () => {
  return (
    <div className="prose bg-white p-8 max-w-3xl max-h-[60vh] mx-auto rounded-2xl shadow-lg overflow-auto">
      <Outlet />
    </div>
  )
}